/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Option } from "@nordcloud/gnui/dist/components/dropdown/types";
import styled, { css } from "styled-components";
import { Dropdown } from "@nordcloud/gnui";

const StyledDropdown = styled(Dropdown)`
  ${({ value }) =>
    value
      ? css`
          > button > span {
          }
        `
      : css`
          > button > span {
            color: #6e6e83;
          }
        `};
`;

type Props = {
  name: string;
  options: Option[];
  onChange: (e: any) => void;
  width?: string;
  value?: string;
  placeholder: string;
  disabled?: boolean;
};

function OvDropdown(props: Props) {
  const dropdownRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (dropdownRef.current && !props.value) {
      const span = dropdownRef.current.querySelector("button > span");
      if (span) {
        span.textContent = props.placeholder;
      }
    }
  }, [dropdownRef, props.value, props.placeholder]);

  return (
    <div ref={dropdownRef}>
      <StyledDropdown
        name={props.name}
        options={props.options}
        onChange={props.onChange}
        width={props.width}
        value={props.value}
        disabled={props.disabled}
      />
    </div>
  );
}

export { OvDropdown };
